/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TreehouseIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABP0lEQVR4nM2UX0rDQBDGF/UKgmC9iFTyKjY7M/uwnSnFPnqNHMriASy+6JtFqr54gOoZlIWmpNvdbZoE6geB7Gbm+01m/yj1H5Rl2UmOfKuRp4By797dXGvjoiiOwLDVKB9A8lt9NMmXJr5rBFobk7z7xq1A1tpjgOEEkD9DZoh8mdOoH4S5HBhOnEe0ak38kqo2p1Efka+Sf4Xy7LwiAHkD5MWutkDUnBfOIwioqilA1VVwMZGng4E9N2bcA5SHzgHGjHvld0S+6BygGsQkALzcTOalH6NRfrwWfquDSpM8Nd6etLVdZ1sAN9kVQJM8Rv/k2tpTTfxaHpwba8/8RSzHodha7XKJgDJfHf154lpYx7icvdZkozpKXw+1K98FUSt1Yl6FQKT6vdsSE7S93OoCVGTcHoA8q+5tf3xQ/QEkcdEvtQIDvAAAAABJRU5ErkJggg==)
 */
export const TreehouseIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.45 6.9 5 6.61v4.88c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V10a2 2 0 1 1 4 0v1.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V6.62l.55.27a1 1 0 1 0 .9-1.78l-7.1-3.56a3 3 0 0 0-2.7 0l-7.1 3.56a1 1 0 1 0 .9 1.78ZM13 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3 13a1 1 0 1 0 0 2h1.59L9 19.41V22a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-2.59L19.41 15H21a1 1 0 1 0 0-2H3Zm13.59 2H15v1.59L16.59 15ZM13 19v-1h-2v1h2Zm-4-2.41L7.41 15H9v1.59Zm4-.59v-1h-2v1h2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
